module.exports = __webpack_public_path__ + "static/media/QuickLinks.23523c5a.svg";